import jwtDecode from 'jwt-decode';

import { GlobalAppState } from 'rdx/state';
import { ErrorReporter } from '@provider-portal/common/utils/errorReporting';

export const selectSessionAccessTokenState = (state: GlobalAppState) => {
  return state.session.accessToken;
};

export const selectSessionRefreshTokenState = (state: GlobalAppState) => {
  return state.session.refreshToken;
};

export const selectLogoutRequestState = (state: GlobalAppState) => {
  return state.authRequest.logoutRequestState;
};

export const selectAccountId = (state: GlobalAppState) => {
  const { accessToken } = state.session;
  if (!accessToken) {
    return undefined;
  }
  try {
    const accountInfo = jwtDecode(accessToken) as undefined | { data?: { account_id: number } };
    return accountInfo?.data?.account_id;
  } catch (e) {
    ErrorReporter.captureException(e);
  }
  return undefined;
};

export const selectAccountVendorPermissions = (state: GlobalAppState): number[] | undefined => {
  const { accessToken } = state.session;
  if (!accessToken) {
    return undefined;
  }
  try {
    const accountInfo = jwtDecode(accessToken) as
      | undefined
      | { data?: { vendor_permissions: { vendor_id: number }[] } };
    return accountInfo?.data?.vendor_permissions.map(
      (vendorPermission) => vendorPermission.vendor_id,
    );
  } catch (e) {
    ErrorReporter.captureException(e);
  }
  return undefined;
};
